export default {
  elements: [],
  element: null,
  unpaginated_elements: [],
}
